"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/articleCreating/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const ModalConfirmDeleteArticle_1 = __importDefault(require("../../../components/modal/ModalConfirmDeleteArticle"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const apis_1 = require("../../../networking/apis");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const component_1 = require("./component");
const BackgroundEditor_1 = __importDefault(require("./component/BackgroundEditor"));
const styles_1 = __importDefault(require("./styles"));
const CreateArticleScreen = (props) => {
    const content_type = props?.route?.params?.content_type;
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigation = (0, native_1.useNavigation)();
    const articleCreating = (0, react_redux_1.useSelector)((state) => state.articleCreatingReducer);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [visibleConfirm, setVisibleConfirm] = (0, react_1.useState)(false);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const refFormValue = (0, react_1.useRef)({
        thumbnail: articleCreating.thumbnail_image,
        title: articleCreating.title,
        content: articleCreating.full_text,
        content_type: articleCreating.content_type || content_type || 1,
        inherited_from_article_id: articleCreating.inherited_from_article_id,
        inherited_from_user_id: articleCreating.inherited_from_user_id,
        inherited_from_user_nickname: articleCreating.inherited_from_user_nickname,
        inherited_from_user_handle: articleCreating.inherited_from_user_handle,
        inherited_from_user_thumbnail: articleCreating.inherited_from_user_thumbnail,
    });
    const refScrollView = (0, react_1.createRef)();
    const isArticle = refFormValue.current.content_type == 1;
    const inheritUserUneditable = !!refFormValue.current.inherited_from_user_id || !!refFormValue.current.inherited_from_article_id;
    const refIsCloseToBottom = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (!content_type && !articleCreating.content_type) {
            navigation.reset({ index: 0, routes: [{ name: Routes_1.default.MAINTABBAR }] });
        }
    }, [articleCreating]);
    (0, react_1.useEffect)(() => {
        const handleBeforeUnload = (event) => {
            const message = 'Are you sure you want to leave?';
            event.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch((0, slice_2.destroyArticleAction)());
        };
    }, []);
    const onSubmit = async () => {
        refFormValue.current.title = refFormValue.current.title.trim();
        refFormValue.current.content = refFormValue.current.content.trim();
        if ((!refFormValue.current.title && !refFormValue.current.content) || !refFormValue.current.title) {
            (0, helpler_1.showDefaultAlert)({
                title: 'エラー',
                content: 'タイトルは必須項目です。'
            });
            return;
        }
        else if (!refFormValue.current.content || refFormValue.current.content == '<p><br></p>') {
            (0, helpler_1.showDefaultAlert)({
                title: 'エラー',
                content: '本文は必須項目です。'
            });
            return;
        }
        dispatch((0, slice_2.createArticleAction)({
            title: refFormValue.current.title,
            full_text: refFormValue.current.content,
            thumbnail_image: refFormValue.current.thumbnail,
            content_type: refFormValue.current.content_type,
            inherited_from_user_id: refFormValue.current.inherited_from_user_id,
            inherited_from_user_nickname: refFormValue.current.inherited_from_user_nickname,
            inherited_from_user_handle: refFormValue.current.inherited_from_user_handle,
            inherited_from_user_thumbnail: refFormValue.current.inherited_from_user_thumbnail
        }));
        (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE_HASHTAG);
    };
    const handlePostArticle = async (status) => {
        const form = new FormData();
        if (!!refFormValue.current.inherited_from_article_id) {
            form.append('inherited_from_article_id', `${refFormValue.current.inherited_from_article_id}`);
        }
        if (!!refFormValue.current.inherited_from_user_id) {
            form.append('inherited_from_user_id', `${refFormValue.current.inherited_from_user_id}`);
        }
        form.append('title', refFormValue.current.title || '無題');
        form.append('content_type', `${refFormValue.current.content_type}`);
        if (!!refFormValue.current.thumbnail) {
            const file = await (0, helpler_1.convertImageUrlToFile)(refFormValue.current.thumbnail);
            if (file) {
                form.append('thumbnail_image', file);
            }
        }
        form.append('price_type', '1');
        const contentResizeImage = (0, helpler_1.changeWidthHeightToPercentage)(refFormValue.current.content || 'サンプルテキスト');
        form.append('full_text', contentResizeImage);
        // form.append('full_text', articleCreating.full_text)
        form.append('posting_datetime', (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss'));
        form.append('status', `${status}`);
        articleCreating.hashtags.map((item, index) => {
            form.append(`hash_tag_name[${index}]`, item);
        });
        setLoading(true);
        apis_1.ArticleApi.postArticle(form)
            .then((response) => {
            const message = status == 0 ?
                "下書きに保存しました"
                :
                    articleCreating.content_type == 1 ?
                        "記事を公開しました"
                        :
                            "自分史を公開しました";
            dispatch(slice_1.default.actions.showToast(message));
            (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                screen: Routes_1.default.DETAIL_STORY,
                params: {
                    id: response.data.article_id
                }
            });
            dispatch((0, slice_2.destroyArticleAction)());
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const handleEditArticle = async (status) => {
        const form = new FormData();
        form.append('title', refFormValue.current.title || '無題');
        form.append('content_type', `${refFormValue.current.content_type}`);
        if (!!refFormValue.current.thumbnail) {
            const file = await (0, helpler_1.convertImageUrlToFile)(refFormValue.current.thumbnail);
            if (file) {
                form.append('thumbnail_image', file);
            }
        }
        if (!!refFormValue.current.inherited_from_user_id && refFormValue.current.inherited_from_user_id != articleCreating.inherited_from_user_id_root) {
            form.append('inherited_from_user_id', `${refFormValue.current.inherited_from_user_id}`);
        }
        form.append('price_type', '1');
        const contentResizeImage = (0, helpler_1.changeWidthHeightToPercentage)(refFormValue.current.content || 'サンプルテキスト');
        form.append('full_text', contentResizeImage);
        // form.append('full_text', articleCreating.full_text)
        form.append('status', `${status}`);
        articleCreating.hashtags.map((item, index) => {
            form.append(`hash_tag_name[${index}]`, item);
        });
        setLoading(true);
        apis_1.ArticleApi.editArticle(articleCreating.article_id, form)
            .then(() => {
            const message = status == 0 ?
                "編集しました"
                :
                    articleCreating.content_type == 1 ?
                        "記事を公開しました"
                        :
                            "自分史を公開しました";
            dispatch(slice_1.default.actions.showToast(message));
            navigation.dispatch(native_1.StackActions.popToTop());
            (0, rootNavigation_1.navigate)(Routes_1.default.DETAIL_STORY, { id: articleCreating.article_id });
            dispatch((0, slice_2.destroyArticleAction)());
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: isArticle ? "記事作成" : '自分史作成', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerText }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => {
                if (!refFormValue.current.title && !refFormValue.current.content) {
                    return (0, rootNavigation_1.goBack)();
                }
                setVisibleConfirm(true);
            }, rightIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerText }, "\u6B21\u3078"), onRightPress: onSubmit }),
        react_1.default.createElement(react_native_1.ScrollView, { ref: refScrollView, contentContainerStyle: { flexGrow: 1 }, onContentSizeChange: () => {
                if (refIsCloseToBottom.current) {
                    refScrollView.current?.scrollToEnd({ animated: false });
                }
            }, onScroll: ({ nativeEvent }) => {
                if (!(0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    return refIsCloseToBottom.current = false;
                }
                refIsCloseToBottom.current = true;
            }, scrollEventThrottle: 1000, showsVerticalScrollIndicator: false },
            react_1.default.createElement(BackgroundEditor_1.default, { defaultSource: refFormValue.current.thumbnail, onChange: (source) => refFormValue.current.thumbnail = source }),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.editContainer, { paddingBottom: inset.bottom }] },
                react_1.default.createElement(react_native_1.View, { style: { paddingHorizontal: (0, scale_1.scale)(16) } },
                    react_1.default.createElement(component_1.AutoHeightInput, { defaultValue: refFormValue.current.title, onChangeText: (val) => refFormValue.current.title = val })),
                react_1.default.createElement(component_1.QuillEditor, { defaultValue: refFormValue.current.content, onChange: (val) => {
                        refFormValue.current.content = val;
                    } }),
                (!!articleCreating.inherited_from_article_id && !articleCreating.inherited_from_user_id)
                    ?
                        null
                    :
                        react_1.default.createElement(component_1.InheritUser
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            defaultValue: refFormValue.current.inherited_from_user_id ?
                                {
                                    user_id: refFormValue.current.inherited_from_user_id,
                                    nickname: refFormValue.current.inherited_from_user_nickname,
                                    user_handle: refFormValue.current.inherited_from_user_handle,
                                    thumbnail_url: refFormValue.current.inherited_from_user_thumbnail
                                }
                                :
                                    undefined, isArticle: isArticle, isShowGuide: !refFormValue.current.inherited_from_user_id && !articleCreating.article_id, onChange: (user) => {
                                refFormValue.current.inherited_from_user_id = user?.user_id || undefined;
                                refFormValue.current.inherited_from_user_nickname = user?.nickname || '';
                                refFormValue.current.inherited_from_user_handle = user?.user_handle || '';
                                refFormValue.current.inherited_from_user_thumbnail = user?.thumbnail_url || '';
                            }, editable: !inheritUserUneditable }))),
        react_1.default.createElement(ModalConfirmDeleteArticle_1.default, { visible: visibleConfirm, onClose: () => setVisibleConfirm(false), title: refFormValue.current.content_type == 2
                ? '自分史の作成を取り消しますか？'
                : '記事の作成を取り消しますか？', content: "\u5165\u529B\u3057\u305F\u5185\u5BB9\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3002", confirmLabel: (!articleCreating.article_id || articleCreating.status == 0)
                ?
                    "下書きに保存する"
                :
                    undefined, cancelLabel: "\u30AD\u30E3\u30F3\u30BB\u30EB", onConfirm: () => { setVisibleConfirm(false), articleCreating.article_id ? handleEditArticle(0) : handlePostArticle(0); }, onConfirm1: () => {
                (0, rootNavigation_1.goBack)();
                setVisibleConfirm(false);
                dispatch((0, slice_2.destroyArticleAction)());
            }, confirmLabel1: "\u7834\u68C4\u3059\u308B" }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = CreateArticleScreen;
